module.exports = __webpack_public_path__ + "static/images/containers/MigrationScreen/images/slide_3.5aa8728a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/images/slide_3.png
// module id = 3207
// module chunks = 11